import { AgencyPageLayout, FlexBox } from '@esg/ui';
import React, { useEffect } from 'react';
import { ChartsSectionContainer, KpiCardContainer, UpcomingRenewalsContainer } from './Containers';
// import {apiFetch} from '@my-monorepo/utils'

const DashboardPage: React.FC = () => {
    useEffect(() => {
    }, []);

    return (
        <AgencyPageLayout pageTitle='Dashboard'>
            <FlexBox direction='column' gap={12}>
                <KpiCardContainer />
                <ChartsSectionContainer />
                <UpcomingRenewalsContainer />
            </FlexBox>
        </AgencyPageLayout>
    );
};

export { DashboardPage };
